/**
 * Placeholder sections available for use.
 * @type {PLACEHOLDER_SECTIONS}
 */
export const PLACEHOLDER_SECTIONS = {
  NUMBER: 'number',
  ISSUE_DATE: 'issueDate',
  PERFORMANCE_DATE: 'performanceDate',
  DUE_DATE: 'dueDate',
  CONTACT_ORGANIZATION: 'contactOrganization',
  CONTACT_CUSTOMER: 'contactCustomer',
  ITEMS_TABLE: 'itemsTable',
  TERMS_AND_CONDITIONS: 'termsAndConditions',
  FOOTER: 'footer',
  DE_CUSTOMER_VAT_NUMBER: 'deCustomerVatNumber',
  DE_CUSTOMER_TIN_NUMBER: 'deCustomerTinNumber',
  DE_PURCHASE_ORDER: 'dePurchaseOrder',
  DE_RELATED_QUOTE: 'deRelatedQuote',
  DE_DUE_DATE_DISCLAIMER: 'deDueDateDisclaimer',
  DE_CUSTOM_MESSAGES: 'deCustomMessages'
};